function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.342057 40.5266L2.72686 55.5836L40.6706 49.5739L11.86 34.4731C9.73633 33.3599 7.13586 33.7543 5.43772 35.4471L0.342057 40.5266Z",
  fill: "url(#paint0_linear)",
  stroke: "#E3E7EE",
  strokeWidth: 0.0907589
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2826 26.9937L8.65564 54.6447L40.6707 49.574L38.0262 32.8773L26.7631 24.4112C23.7913 22.1774 19.505 23.4826 18.2826 26.9937Z",
  fill: "url(#paint1_linear)",
  stroke: "#C8CCD4",
  strokeWidth: 0.0907589
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.77287,
  cy: 17.278,
  r: 4.80209,
  transform: "rotate(-9 7.77287 17.278)",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M85.8378 26.4986L70.4497 46.7745L98.2824 51.1828L100.581 36.6673L93.5434 26.6416C91.6863 23.9962 87.7918 23.9239 85.8378 26.4986Z",
  fill: "url(#paint3_linear)",
  stroke: "#C8CCD4",
  strokeWidth: 0.0789025
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 79.7584,
  cy: 15.6422,
  r: 4.17476,
  transform: "rotate(9 79.7584 15.6422)",
  fill: "url(#paint4_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4775 35.8306V55.9992H77.3025L42.7809 30.3042C40.2363 28.4102 36.7566 28.3873 34.1873 30.2478L26.4775 35.8306Z",
  fill: "url(#paint5_linear)",
  stroke: "#D4EBFF",
  strokeWidth: 0.0907589
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M52.7212 21.86L34.4189 55.9992H77.3025V33.6343L64.3372 20.2406C60.9162 16.7066 55.0452 17.525 52.7212 21.86Z",
  fill: "#0BA2F3",
  stroke: "#0C71A7",
  strokeWidth: 0.181518
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.999,
  cy: 6.98972,
  r: 6.35312,
  fill: "url(#paint6_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 10.2612,
  y1: 43.165,
  x2: 8.68625,
  y2: 27.9923,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02897,
  stopColor: "#E3E7EE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBFCFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 28.4121,
  y1: 39.9888,
  x2: 19.8969,
  y2: 19.3061,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C8CCD4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBEFF5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 9.43177,
  y1: 18.7084,
  x2: 5.10422,
  y2: 9.83543,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C8CCD4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBEFF5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 90.7219,
  y1: 39.9643,
  x2: 89.2378,
  y2: 20.576,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C8CCD4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBEFF5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 81.2006,
  y1: 16.8858,
  x2: 77.4383,
  y2: 9.17195,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C8CCD4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBEFF5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 38.8928,
  y1: 41.3312,
  x2: 39.975,
  y2: 21.179,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D1EFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D5F0FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 43.9638,
  y1: 11.2251,
  x2: 29.1398,
  y2: -8.68131,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#009EF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EF2",
  stopOpacity: 0
})));

function SvgDropzoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 56,
    viewBox: "0 0 103 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropzoneIcon);
export default __webpack_public_path__ + "static/media/dropzone-icon.564ed1a4.svg";
export { ForwardRef as ReactComponent };